// extracted by mini-css-extract-plugin
module.exports = {"shelf":"Shelf_shelf__LnwVA","shelf__products":"Shelf_shelf__products__65bcW","hidden":"Shelf_hidden__r_xLk"};